import { parseISO } from "date-fns"
import { z } from "zod"

export const ISODateScheme = z.string().transform((str) => parseISO(str))
export const ISODateTimeScheme = ISODateScheme
